export class Approval {
    Id: number;
    IsApproved: boolean;
    ReturnToMainStock: boolean;
    ReturnFromMainStock: boolean;
    List: Approval[];
    
    constructor( pId?: number, pIsApproved?: boolean, pAddToMainStock?: boolean, pReturnFromMainStock?: boolean ) {
        if ( pId ) {
            this.Id = pId;
        }
        if ( pIsApproved != null ) {
            this.IsApproved = pIsApproved;
        }
        if ( pAddToMainStock != null ) {
            this.ReturnToMainStock = pAddToMainStock;
        }
        if ( pReturnFromMainStock != null ) {
            this.ReturnFromMainStock = pReturnFromMainStock;
        }
    }
}
